import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DashBoardService } from './dashboard.service';
import { AuthService } from '../services/auth.service';
import { ModalDirective } from 'ng2-bootstrap';
import { DMCoQuan } from '../he-thong/dm-co-quan/dm-co-quan';
import { DMCoQuanService } from '../he-thong/dm-co-quan/dm-co-quan.service';
import { QuyTrinhXuLyService } from '../quy-trinh-xu-ly/quy-trinh-xu-ly.service';
import { ThongBaoService} from '../he-thong/thong-bao/thong-bao.services';
import { XlXuLySuCoService } from 'app/xu-ly/xl-xu-ly-su-co/xl-xu-ly-su-co.service';

declare var Chart:any;
declare var jQuery:any;
var FileSaver = require('file-saver');
@Component({
    selector: 'vnpt-home',
    templateUrl: './home.component.html',
    styleUrls:['../../assets/css/table-scroll.css','../../assets/css/tableFixDashBoard.css'],
    providers: [ DashBoardService, DMCoQuanService, QuyTrinhXuLyService, ThongBaoService, XlXuLySuCoService ]
})
export class HomeComponent implements OnInit {

    title = 'Trang Chủ';
    dataPie: number[] = [];
    dataBar: number[] = [];
    labelBar: number[] = [];
    dataPieSuCo: any;
    dataBarSuCo: any;
    pieChart: any;
    barChart: any;
    dataStatistic: any = { TONGPA: 0, TONGQH: 0, TONGPADXL: 0, TONGPADONG: 0 };
    dataPie2: number[] = [];
    dataBar2: number[] = [];
    labelBar2: number[] = [];
    dataPieSuCo2: any;
    dataBarSuCo2: any;
    pieChart2: any;
    barChart2: any;
    dataStatistic2: any = { TONGPA: 0, TONGQH: 0 };

    dataPie3: number[] = [];
    dataBar3: number[] = [];
    labelBar3: number[] = [];
    dataPieSuCo3: any;
    dataBarSuCo3: any;
    pieChart3: any;
    barChart3: any;

    success: boolean = false;
    error: boolean = false;
    status: boolean = false;
    successMessage: string = "";
    errorMessage: string = "";
    statusMessage: string = "";

    errorPop: boolean = false;
    statusPop: boolean = false;
    messagePop: string = "";

    paging: number = 1;
    totalCount: number = 0;
    totalPages: number = 1;
    total: number;
    page: number = 1;
    pagesize: number = 50;

    TieuDeMoDal: string = "";
    listDanhSach: any[] = [];
    listDanhSach_Detail: any[] = [];

    indexTab: number = 2;
    loai: number = 1;
    nangcap: number = 1;
    num_bieudo: number = 0; // 1: pie sự cố sp, 2: pie nâng cấp sp, 3: bar sự cố sp, 4: bar nâng cấp sp, 5: pie sự cố tb, 6: bar sự cố tb
    indexTab_ThoiGian1: number = 2; // 1: ngày, 2: tháng, 3: năm
    indexTab_ThoiGian2: number = 2; // 1: ngày, 2: tháng, 3: năm
    indexTab_ThoiGian3: number = 1; // 1: sự cố sp theo ngày
    indexTab_ThoiGian4: number = 1; // 1: nâng cấp sp theo ngày
    indexTab_ThoiGian5: number = 2; // 1: ngày, 2: tháng, 3: năm
    indexTab_ThoiGian6: number = 1; // 1: sự cố tb theo ngày
    flg_statistic: boolean;
    flg_detail: boolean = false;
    flg_bar: boolean = false;
    ngay: number = 1;
    YeuCau: any = {};
    selectedDetailItem: any;
    @ViewChild("lgModalChiTietYC") lgModalChiTietYC: ModalDirective;
    @ViewChild("lgModalHienThiChiTiet") lgModalHienThiChiTiet: ModalDirective;
    @ViewChild("lgModalHienThi") lgModalHienThi: ModalDirective;
    @ViewChild("lgModalChiTietDashBoard") lgModalChiTietDashBoard: ModalDirective;
    @ViewChild("lgModalHienThiChiTietBoSungThietBi") lgModalHienThiChiTietBoSungThietBi: ModalDirective;
    @ViewChild("lgModalChiTietPhieuTon") lgModalChiTietPhieuTon: ModalDirective;
    
    CoQuan:any = {Id:0, Ten:'Tất cả cơ quan'};    
    SanPham:any = {IdSanPham:0, Ten:'--- Tất cả sản phẩm ---'};
    listCoQuan: DMCoQuan[] = [];
    listSanPham: any = [];    
    tuNgay:string="";
    public constructor(private titleService: Title,
        private dashboardSevice: DashBoardService,
        private router: Router,
        public auth: AuthService,
        private coquanService: DMCoQuanService,        
        private svThongBao:ThongBaoService,
        private service: XlXuLySuCoService,
        
    ) {

    }
    myFunction(val) {
    
        var dots = document.getElementById("dots"+val);
        var moreText = document.getElementById("more"+val);
        var btnText = document.getElementById("bt"+val);
      
        if (dots.style.display === "none") {
          dots.style.display = "inline";
          btnText.innerText = 'Xem thêm';          
          moreText.style.display = "none";
          
        } else {
          dots.style.display = "none";
          btnText.innerText = 'Ẩn';
          moreText.style.display = "inline";
        
        }
    }
    tabIndex:number=0;
    public changePie(option: number): void {
        this.tabIndex = option;
        // if(option = 0)
        //     this.GetBarDangKy();
        // else
        //     this.GetPieNguoiDungPhanAnh();
    }

    public changeBar(option: number): void {
        this.indexTab_ThoiGian3 = option;
        //this.GetBarChart(option, 0, 0);
    }
        
    GetPieNguoiDungPhanAnh()
    {
        this.ShowAlert("Đang truy vấn dữ liệu từ server ...", "status");
        let ds = [];       
        
        this.dashboardSevice.GetPieNguoiDungPhanAnh().subscribe
        (
            (data) =>
            {         
                
                for(let i = 0; i < data.length; i++){
                    let item = data[i];
                    ds.push(item);
                }         
                this.dataPie = ds;                
                this.dataPieSuCo = {
                    datasets:
                    [
                        {
                            data: this.dataPie,
                            backgroundColor:
                            [
                                "#E91E63",
                                "#00BCD4"
                            ]
                        }
                    ],
                    labels:
                    [
                        "Số người đăng ký chưa gửi phản ánh",
                        "Số người đăng ký đã gửi phản ánh",
                    ]
                };
                if(this.pieChart != undefined){
                    this.pieChart.config.data = this.dataPieSuCo;
                    this.pieChart.config.options.title.text = "Biểu đồ tỷ lệ người dùng có phản ánh đến thời điểm hiện tại";
                    this.pieChart.update();                       
                }                   
                this.HideAlert("status");
            },
            er =>
            {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.HideAlert("status");
            }
        );
    }

    // GetPieChart_TongHop(option: number, nangcap: number, group: number, loai: number, loaidoituong: number)
    // {
    //     this.ShowAlert("Đang truy vấn dữ liệu từ server ...", "status");
    //     this.dashboardSevice.GetPieChart_TongHop(this.CoQuan.Id, this.SanPham.IdSanPham, option, nangcap, group, loai, loaidoituong).subscribe
    //     (
    //         (data) =>
    //         {
    //             this.listDanhSach = data;
    //             this.HideAlert("status");
    //         },
    //         er =>
    //         {
    //             if (er.status == 401) {
    //                 this.router.navigate(['./login']);
    //             }
    //             this.HideAlert("status");
    //         }
    //     );
    // }

    // GetPieChart_ChiTiet(page: number, iddoituong: number, option: number, nangcap: number, group: number, loai: number, loaidoituong: number)
    // {
    //     this.ShowAlert("Đang truy vấn dữ liệu từ server ...", "status");
    //     this.dashboardSevice.GetPieChart_ChiTiet(page, this.pagesize, iddoituong, this.CoQuan.Id, this.SanPham.IdSanPham, option, nangcap, group, loai, loaidoituong).subscribe
    //     (
    //         (data) =>
    //         {
    //             this.listDanhSach_Detail = data;
    //             this.HideAlert("status");
    //             if (this.listDanhSach_Detail.length !== 0)
    //             {
    //                 // tổng records trong list
    //                 this.paging = page;
    //                 this.totalCount = (data[0]).TotalRows;
    //                 this.totalPages = Math.ceil(this.totalCount / this.pagesize); // tính tổng số trang cần phân dựa vào tổng records
                    
    //                 this.TaoTongTrang(this.paging, this.totalPages);
    //             }
    //             else
    //             {
    //                 if (page > 1) {
    //                     this.GetPieChart_ChiTiet(page - 1, iddoituong, option, nangcap, group, loai, loaidoituong);
    //                 } else {
    //                     this.totalPages = 0;
    //                 }
    //             }
    //         },
    //         er =>
    //         {
    //             if (er.status == 401) {
    //                 this.router.navigate(['./login']);
    //             }
    //             this.HideAlert("status");
    //         }
    //     );
    // }

    GetBarDangKy()
    {
        this.ShowAlert("Đang truy vấn dữ liệu từ server ...", "status");
        this.dashboardSevice.GetBarDangKy(this.tuNgay).subscribe
        (
            (data) =>
            {
                this.dataBar = data.datas;
                this.labelBar = data.labels;
                this.dataBarDangKy = {
                    labels: this.labelBar,
                    datasets: [{
                        label: "Số người dùng đăng ký trong ngày",
                        data: this.dataBar,
                        backgroundColor: 'rgba(0, 188, 212, 0.8)'
                    }]
                };
                if(this.barChart != undefined){
                    this.barChart.config.data = this.dataBarDangKy;
                    let dataBar_tmp: number[] = this.dataBar.slice(0, this.dataBar.length);
                    let max: number = dataBar_tmp.sort((n1, n2) => n2 - n1)[0];
                    this.barChart.config.options.scales.yAxes[0].ticks.max = max + (max < 10 ? 1 : Math.round(max / 10));
                    if (max < 10) this.barChart.config.options.scales.yAxes[0].ticks.stepSize = 1; else delete this.barChart.config.options.scales.yAxes[0].ticks.stepSize;
                    this.barChart.config.options.title.text = "Biểu đồ người dùng đăng ký theo ngày trong tháng " + (new Date().getMonth() + 1) + "/" + (new Date().getFullYear());
                    this.barChart.update();
                }
            },
            er =>
            {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.HideAlert("status");
            }
        );
    }
    GetBarPhanAnh()
    {
        this.ShowAlert("Đang truy vấn dữ liệu từ server ...", "status");
        this.dashboardSevice.GetBarPhanAnh(this.tuNgay).subscribe
        (
            (data) =>
            {
                this.dataBar = data.datas;
                this.labelBar = data.labels;
                this.dataBarPhanAnh = {
                    labels: this.labelBar,
                    datasets: [{
                        label: "Số sự cố trong ngày",
                        data: this.dataBar,
                        backgroundColor: 'rgba(0, 188, 212, 0.8)'
                    }]
                };
                if(this.barChart2 != undefined){
                    this.barChart2.config.data = this.dataBarPhanAnh;
                    let dataBar_tmp: number[] = this.dataBar.slice(0, this.dataBar.length);
                    let max: number = dataBar_tmp.sort((n1, n2) => n2 - n1)[0];
                    this.barChart2.config.options.scales.yAxes[0].ticks.max = max + (max < 10 ? 1 : Math.round(max / 10));
                    if (max < 10) this.barChart2.config.options.scales.yAxes[0].ticks.stepSize = 1; else delete this.barChart2.config.options.scales.yAxes[0].ticks.stepSize;
                    this.barChart2.config.options.title.text = "Biểu đồ phản ánh phát sinh theo ngày trong tháng " + (new Date().getMonth() + 1) + "/" + (new Date().getFullYear());
                    this.barChart2.update();
                }
            },
            er =>
            {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.HideAlert("status");
            }
        );
    }

    GetBarChart_TongHop(option: number, nangcap: number, group: number, loai: number, ngay: number, loaidoituong: number)
    {
        this.ShowAlert("Đang truy vấn dữ liệu từ server ...", "status");
        this.dashboardSevice.GetBarChart_TongHop(this.CoQuan.Id, this.SanPham.IdSanPham, option, nangcap, group, loai, ngay, loaidoituong).subscribe
        (
            (data) =>
            {
                this.listDanhSach = data;
                this.HideAlert("status");
            },
            er =>
            {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.HideAlert("status");
            }
        );
    }

    GetBarChart_ChiTietNew(page:number, option: number, loai: number, ngay:number)
    {
        this.ShowAlert("Đang truy vấn dữ liệu từ server ...", "status", true);
        this.listDanhSach_Detail = [];
        this.dashboardSevice.GetBarChart_ChiTietNew(page, this.pagesize, this.CoQuan.Id, this.SanPham.IdSanPham, option, loai, ngay).subscribe
        (
            (data) =>
            {
                this.listDanhSach_Detail = data;
                this.statusPop=false;
                if (this.listDanhSach_Detail.length !== 0)
                {
                    // tổng records trong list
                    this.paging = page;
                    this.totalCount = (data[0]).TOTALROWS;
                    this.totalPages = Math.ceil(this.totalCount / this.pagesize); // tính tổng số trang cần phân dựa vào tổng records
                    
                    this.TaoTongTrang(this.paging, this.totalPages);
                }
                else
                {
                    if (page > 1) {
                        this.GetBarChart_ChiTietNew(page - 1, option, loai, ngay);
                    } else {
                        this.totalPages = 0;
                    }
                }
            },
            er =>
            {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.HideAlert("status");
            }
        );
    }
    ngOnInit()
    { 
        this.router.navigate(['./login']);
        this.titleService.setTitle(this.title);
        this.KhoiTao();
        // this.GetListCoQuan().then(()=>{
        //     this.GetListDanhSachSanPham().then(()=>{
        //         this.KhoiTao();
        //     });
        // });
        // if(this.auth.user.ThongBao > 0){
        //     this.load_thongbao();     
        // }      
        // this.Load_dsDashBoardThietBiCSHT().then(()=>{
        //     this.Load_dsDashBoardThietBiCSHTKhuVuc();  
        // });
        // this.Load_dsDashBoardThamDinhPhuongAn();
        // this.Load_dsDashBoardThamDinhPhuongAnTinh();
        // this.DashBoardTongHopTon();
        // jQuery('.modal-dialog').draggable();          
    }
    dataBarDangKy:any;
    dataBarPhanAnh:any;
    KhoiTao()
    {       
        //this.GetStatistic(1, 0);
        //this.GetStatistic(2, 1);        
        this.dataPieSuCo = {
            datasets:
            [
                {
                    data: [],
                    backgroundColor:
                    [
                        "#FF6384",
                        "#8bc34a",
                        "#36A2EB"
                    ]
                }
            ],
            labels:
            [
                "Chưa xử lý",
                "Đã xử lý",
                "Đã xác nhận"
            ]
        };

        this.dataBarDangKy = {
            labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30"],
            datasets: [{
                label: "Số người dùng đăng ký trong ngày",
                data: [],
                backgroundColor: 'rgba(0, 188, 212, 0.8)'
            }]
        };
        this.dataBarPhanAnh = {
            labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30"],
            datasets: [{
                label: "Số phản ánh trong ngày",
                data: [],
                backgroundColor: 'rgba(0, 188, 212, 0.8)'
            }]
        };

        //this.GetPieChart(2, 0, 0);        
        this.GetBarDangKy();
        this.GetBarPhanAnh();
        this.GetPieNguoiDungPhanAnh();
        //this.GetBarChart(1, 1, 0);

        //this.GetPieChart(2, 0, 1);
        //this.GetBarChart(1, 0, 1);

        Chart.defaults.global.legend.display = true;
        Chart.defaults.global.tooltips.enabled = true;
        // Cấu hình pie chart
        var pieOptions = {
            responsive: true,
            title: {
                display: true,
                text: 'Custom Chart Title',
                position: 'bottom'
            },
            legend: {
                display: true,
                position: 'top',
                labels: {
                    generateLabels: function (chart) {
                        var data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            return data.labels.map(function (label, i) {
                                var meta = chart.getDatasetMeta(0);
                                var ds = data.datasets[0];                                
                                var arc = meta.data[i];
                                var custom = arc && arc.custom || {};
                                var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
                                var arcOpts = chart.options.elements.arc;
                                var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
                                var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
                                var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

                                // We get the value of the current label
                                //var value = chart.config.data.datasets[arc.datasetIndex].data[arc.index];
                                var value = chart.config.data.datasets[0].data[i];

                                return {
                                    // Instead of `text: label,`
                                    // We add the value to the string
                                    text: label + ": " + (value == null ? 0 : value),
                                    fillStyle: fill,
                                    strokeStyle: stroke,
                                    lineWidth: bw,
                                    hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                                    index: i
                                };
                            });
                        } else {
                            return [];
                        }
                    }
                }
            },
            tooltips: {
                mode: 'label',
                callbacks: {
                    label: function (tooltipItem, data) {
                        var indice = tooltipItem.index;
                        return data.labels[indice] + ': ' + data.datasets[0].data[indice] + '';
                    }
                }
            }
        };
        
        // Cấu hình bar chart
        //// Chart options
        //Chart.defaults.global.legend.display = false;
        //Chart.defaults.global.tooltips.enabled = false;

        var barOptionsDangKy = {
            responsive: true,
            legend: true,
            title: {
                display: true,
                text: 'Custom Chart Title',
                position: 'bottom'
            },
            tooltips: {
                callbacks: {
                    title: function (tooltipItems, data) {
                        return "Ngày: " + tooltipItems[0].xLabel;
                    },
                    label: function (tooltipItem, data) {
                        return "Số người dùng đăng ký trong ngày: " + tooltipItem.yLabel;
                    }
                }
            },
            animation: {
                //duration: 0,                
                onComplete: function () {
                    // render the value of the chart above the bar
                    var ctx = this.chart.ctx;
                    ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                    ctx.fillStyle = this.chart.config.options.defaultFontColor;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'bottom';
                    this.data.datasets.forEach(function (dataset) {
                        for (var i = 0; i < dataset.data.length; i++) {
                            var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                            if (dataset.data[i] > 0) ctx.fillText(dataset.data[i], model.x, model.y - 2);
                        }
                    });
                }
            },
            scales: {
                yAxes: [{
                    ticks: {
                        min: 0/*,
                        stepSize: 508*/
                        ,max: 10
                    }                    
                }]
            }

        };
        var barOptionsPhanAnh = {
            responsive: true,
            legend: true,
            title: {
                display: true,
                text: 'Custom Chart Title',
                position: 'bottom'
            },
            tooltips: {
                callbacks: {
                    title: function (tooltipItems, data) {
                        return "Ngày: " + tooltipItems[0].xLabel;
                    },
                    label: function (tooltipItem, data) {
                        return "Số phản ánh phát sinh trong ngày: " + tooltipItem.yLabel;
                    }
                }
            },
            animation: {
                //duration: 0,                
                onComplete: function () {
                    // render the value of the chart above the bar
                    var ctx = this.chart.ctx;
                    ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                    ctx.fillStyle = this.chart.config.options.defaultFontColor;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'bottom';
                    this.data.datasets.forEach(function (dataset) {
                        for (var i = 0; i < dataset.data.length; i++) {
                            var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                            if (dataset.data[i] > 0) ctx.fillText(dataset.data[i], model.x, model.y - 2);
                        }
                    });
                }
            },
            scales: {
                yAxes: [{
                    ticks: {
                        min: 0/*,
                        stepSize: 508*/
                        ,max: 10
                    }                    
                }]
            }

        };
        
        // Khai báo chart 
        var pieChartCanvas = $("#pieDangKyPA");
        this.pieChart = new Chart(pieChartCanvas, {
            type: 'pie', // or doughnut
            data: this.dataPieSuCo,
            options: pieOptions
        });

        this.pieChart.config.options.onClick = (event:any, active:Array<any>) => {
            this.num_bieudo = 1; 
            console.log(active[0]._model.label);
            if(active[0]._model.label == "Phiếu chưa xử lý")
                this.showPop(2);            
            else if(active[0]._model.label == "Phiếu đã xử lý")
                this.showPop(3);
            else if(active[0]._model.label == "Phiếu chờ đóng")
                this.showPop(3,0, true);
            else
                this.showPop(1);
        };

        var barChartCanvas = $("#barDangKy");
        this.barChart = new Chart(barChartCanvas, {
            type: 'bar', // or doughnut
            data: this.dataBarDangKy,
            options: barOptionsDangKy            
        }); 

        var barChartCanvas = $("#barPhanAnh");
        this.barChart2 = new Chart(barChartCanvas, {
            type: 'bar', // or doughnut
            data: this.dataBarPhanAnh,
            options: barOptionsPhanAnh          
        });  

        this.barChart.config.options.onClick = (event:any, active:Array<any>) => {
            this.num_bieudo = 3;            
            this.showPop(0, active[0]._model.label, false);
        };        
    }

    Chart(){
        // Chart 
        //----------------Do du lieu-------------------
    }      
    
    showPop(loai: number, ngay:number = 0, flg_statistic: boolean = false) //khanh
    {        
        this.flg_bar = false;
        this.flg_detail = false;
        this.loai = loai;       
        
        if(this.num_bieudo == 1) // toan trinh
        {
            this.TieuDeMoDal = (loai == 1 ? "Tổng phiếu tồn chưa xử lý toàn trình" : (loai == 2 ? "Tổng phiếu chưa xử lý toàn trình": (loai == 3? "Tổng phiếu chờ xác nhận đóng toàn trình":(loai == 4?"Tổng phiếu đã đóng trong tháng " + this.GetMonth():"Tổng phiếu quá hạn toàn trình"))));
            this.GetBarChart_ChiTietNew(1, 1, loai, ngay);          
            this.lgModalHienThiChiTiet.show();
        }
        else if(this.num_bieudo == 2) // phongban
        {
            this.TieuDeMoDal = loai ==1?"Tổng phiếu chưa xử lý phòng ban":"Tổng phiếu chưa xử lý quá hạn phòng ban";
            this.GetBarChart_ChiTietNew(1, 2, loai, ngay);          
            this.lgModalHienThiChiTiet.show();
        }
        else if(this.num_bieudo == 3) // biểu đồ hình cột theo ngày
        {
            this.TieuDeMoDal = "Tổng phiếu phòng ban theo ngày " + this.GetD();
            this.GetBarChart_ChiTietNew(1, 3, loai, ngay);          
            this.lgModalHienThiChiTiet.show();
        }
    }    

    // onChangeTabPop(option: number)
    // {
    //     this.flg_detail = false;
    //     this.indexTab = option;
    //     if(this.flg_bar)
    //     {
    //         if(this.nangcap == 0 && (this.num_bieudo == 3 || this.num_bieudo == 4))
    //             this.GetBarChart_TongHop(this.indexTab_ThoiGian3, this.nangcap, this.indexTab, 1, this.ngay, 0);
    //         else if(this.nangcap == 1 && (this.num_bieudo == 3 || this.num_bieudo == 4))
    //             this.GetBarChart_TongHop(this.indexTab_ThoiGian4, this.nangcap, this.indexTab, 1, this.ngay, 0);
    //         else
    //             this.GetBarChart_TongHop(this.indexTab_ThoiGian6, this.nangcap, this.indexTab, 1, this.ngay, 1);
    //     }
    //     else
    //     {
    //         if(this.flg_statistic)
    //         {
    //             if(this.nangcap == 0)
    //                 this.GetPieChart_TongHop(2, this.nangcap, this.indexTab, this.loai, 0);
    //             else
    //                 this.GetPieChart_TongHop(2, this.nangcap, this.indexTab, this.loai, 0);
    //         }
    //         else
    //         {
    //             if(this.nangcap == 0 && (this.num_bieudo == 1 || this.num_bieudo == 2))
    //                 this.GetPieChart_TongHop(this.indexTab_ThoiGian1, this.nangcap, this.indexTab, this.loai, 0);
    //             else if(this.nangcap == 1 && (this.num_bieudo == 1 || this.num_bieudo == 2))
    //                 this.GetPieChart_TongHop(this.indexTab_ThoiGian2, this.nangcap, this.indexTab, this.loai, 0);
    //             else
    //                 this.GetPieChart_TongHop(this.indexTab_ThoiGian5, this.nangcap, this.indexTab, this.loai, 1);
    //         }
    //     }
    // }

    onSelectChiTiet(item)
    {
        this.selectedDetailItem = item;

    }


    checkDisableTB()
    {
        if(this.num_bieudo == 1 || this.num_bieudo == 2 || this.num_bieudo == 3 || this.num_bieudo == 4)
            return true;
        else
            return false;
    }

    checkDisableSP()
    {
        if(this.num_bieudo == 5 || this.num_bieudo == 6)
            return true;
        else
            return false;
    }

    DanhSachTrang = [];
    TaoTongTrang(tranghientai, tongtrang)
    {
        let sotrang_hienthi = 10;
        let min = 0, max = sotrang_hienthi;
        if(tongtrang <  sotrang_hienthi)
        {
            sotrang_hienthi = tongtrang;      
        } 
        if(tranghientai <= sotrang_hienthi/2)
        {
            min = min+1;
            max = sotrang_hienthi;
        }
        else if(tranghientai > tongtrang - (sotrang_hienthi/2))
        {
            min = tongtrang - sotrang_hienthi + 1;
            max = tongtrang;      
        }
        else
        {
            min = tranghientai - (sotrang_hienthi/2) + 1;
            max = tranghientai + (sotrang_hienthi/2);
        }
        let stt = 0;
        this.DanhSachTrang = [];
        while(min <= max)
        {      
            this.DanhSachTrang.push(min++);
        }
    }

    GetMonth()
    {
        return "T" + (new Date().getMonth() + 1); // + "/" + (new Date().getFullYear());
    }
    GetDD(ngay: number)
    {
        return ngay + "/" + (new Date().getMonth() + 1) + "/" + (new Date().getFullYear());        
    }
    GetD()
    {
        return (new Date().getDate()) + "/" + (new Date().getMonth() + 1) + "/" + (new Date().getFullYear());        
    }
    GetM()
    {
        return (new Date().getMonth() + 1) + "/" + (new Date().getFullYear());
    }
    GetY()
    {
        return (new Date().getFullYear());
    }

    ShowAlert(message: string, option: string, pop: boolean = false)
    {
        if(pop) {
            if (option == "error") {
                this.messagePop = message;
                this.errorPop = true;
                setTimeout(() => this.errorPop = false, 3000);
            }
            else {
                this.messagePop = message;
                this.statusPop = true;
            }
        }
        else {        
            if (option == "success") {
                this.successMessage = message;
                this.success = true;                
                setTimeout(() => this.success = false, 3000);
            }
            else if (option == "error") {
                this.errorMessage = message;
                this.error = true;                
                setTimeout(() => this.error = false, 3000);
            }
            else {                
                this.statusMessage = message;
                this.status = true;
            }
        }
    }

    HideAlert(option: string, pop: boolean = false)
    {
        if(pop) {
            if (option == "error")
                this.errorPop = false;
            else if(option == "status")
                this.statusPop=false;
            else                
                setTimeout(() => this.statusPop = false, 1000);
        }
        else {
            if (option == "success")
                this.success = false;
            else if (option == "error")
                this.error = false;
            else if (option =="status"){
                this.status=false;
            }else
                setTimeout(() => this.status = false, 1000);            
        }        
    }
    onselectYeuCau(item) {
        this.YeuCau = item;
        this.lgModalChiTietYC.show();
    }
    DongModal(){
        this.lgModalChiTietYC.hide();
    }

    GetListDanhSachSanPham():Promise<void>
    {
        return new Promise<void>(resolve=>{
          this.dashboardSevice.GetListSPByCoQuan(this.CoQuan.Id)
              .subscribe(
                  (data) => {
                      this.listSanPham=[];
                      this.listSanPham = data;
                     
                      this.SanPham.IdSanPham = 0;
                      resolve();
                  },
                  er =>{
                      if (er.status == 401){
                          this.router.navigate(['./login']);
                      }
                  }
              );
        });
    }

    chonSanPham(){
        //this.KhoiTao();        
        //this.GetStatistic(1, 0);              
        //this.GetPieChart(2, 0, 0);       
        //this.GetBarChart(1, 0, 0);        
    }

    GetListCoQuan():Promise<void>{
        return new Promise<void>(resolve=>{            
            this.coquanService.GetListByDonVi(this.auth.user.IdDonVi)
            .subscribe(
                (data) => {
                        this.listCoQuan = data;
                        this.CoQuan.Id = this.auth.user.IdCoQuan; 
                        resolve();    
                                  
                    },
                er =>{
                    if (er.status == 401){
                        this.router.navigate(['./login']);
                    }
                }
            ); 
        });
    }
    
    chonCoQuan(){
        //this.GetStatistic(1, 0);              
        //this.GetPieChart(2, 0, 0);       
        //this.GetBarChart(1, 0, 0);

        // this.GetListDanhSachSanPham().then(()=>{
        //     //this.KhoiTao();
            
        //     this.GetStatistic(2, 0);
        //     //this.GetStatistic(2, 1);
            
        //     this.GetPieChart(2, 0, 0);
        //     //this.GetPieChart(this.indexTab_ThoiGian2, 1, 0);
        //     //this.GetBarChart(this.indexTab_ThoiGian3, 0, 0);
        //     //this.GetBarChart(this.indexTab_ThoiGian4, 1, 0);
            
        //     //this.GetPieChart(this.indexTab_ThoiGian5, 0, 1);
        //     this.GetBarChart(this.indexTab_ThoiGian6, 0, 1);
        // });
    }
    thongBao:any={};
    load_thongbao(){
        this.svThongBao.ds_thongbao(1).subscribe(
            resp=>{
                if(resp.length > 0){
                    this.thongBao.NOIDUNG = resp[0].NOIDUNG;
                    this.thongBao.DUONGDAN = resp[0].DUONGDAN;
                }
            }
        )
    }
    chonThongBao(){
        console.log(this.thongBao);
        this.router.navigate([this.thongBao.DUONGDAN]);
    }
    HienThiHTML: string = "";
    TieuDeModal: string = "";
    XL: any = {};
    onselectLichSu(item) {           
        this.XL = item;    
        this.lgModalHienThi.show();
        this.HienThiHTML = "lich_su";
        this.TieuDeModal = "Lịch sử xử lý yêu cầu: PAKH:" + item.IDYEUCAU +"/Điện thoại:" + item.DIENTHOAI +"/Khách hàng:" + item.TENKHACHHANG;
    }
    XuatExcelLichSu() {  
        this.status=true;    
        this.service.XuatExcel(this.XL.IDYEUCAU).subscribe(
            resp => {
                this.status=false;
                var blob = new Blob([resp], { type: "application/octet-stream" });
                FileSaver.saveAs(blob, 'LichSuXuLyPA.xlsx');                
            }
        );
    }
    DongModalLichSu() {
        this.lgModalHienThi.hide();
        this.HienThiHTML = '';
    }
    IconTieuDeModal:boolean=false;
    IconClickBack() {        
        this.IconTieuDeModal = false;
    }
    nCol:number=12;
    nTBCSHT: number=0;
    nMB:number=0;
    nMT:number=0;
    nMN:number=0;
    dsDashBoardThietBiCSHT:any=[];
    Load_dsDashBoardThietBiCSHT():Promise<void>
    {
        return new Promise<void>(resolve=>{
            let TT={
                IdCoQuan:this.auth.user.IdCoQuan
            };
            this.dashboardSevice.ds_DashBoardThietBiCSHT(TT).subscribe(
                resp=>{
                    this.dsDashBoardThietBiCSHT = resp;
                    if(this.dsDashBoardThietBiCSHT.length)
                        this.nTBCSHT = 1;
                    resolve();              
                }
            )
        })
    }    
    dsDashBoardThietBiCSHTKhuVuc_MB:any=[];
    dsDashBoardThietBiCSHTKhuVuc_MT:any=[];
    dsDashBoardThietBiCSHTKhuVuc_MN:any=[];
    Load_dsDashBoardThietBiCSHTKhuVuc(){
        let TT={
            IdCoQuan:this.auth.user.IdCoQuan
        };
        this.dashboardSevice.ds_DashBoardThietBiCSHTKhuVuc(TT).subscribe(
            resp=>{
                this.dsDashBoardThietBiCSHTKhuVuc_MB = resp.filter(f=>f.KHUVUC == 161);                
                this.dsDashBoardThietBiCSHTKhuVuc_MT = resp.filter(f=>f.KHUVUC == 141);
                this.dsDashBoardThietBiCSHTKhuVuc_MN = resp.filter(f=>f.KHUVUC == 162);
                if (this.dsDashBoardThietBiCSHTKhuVuc_MB.length > 0)
                    this.nMB=1;
                if(this.dsDashBoardThietBiCSHTKhuVuc_MT.length > 0)
                    this.nMT = 1;
                if(this.dsDashBoardThietBiCSHTKhuVuc_MN.length > 0)
                    this.nMN = 1;
                                   
                this.nCol = this.nCol/(this.nTBCSHT + this.nMB + this.nMT + this.nMN);                
            }
        )
    }    
    chiTietThietBiCSHT:any={};
    tieuDeChiTietDSB:string="";
    xemChiTietThietBiCSHTKhuVuc(item, Loai:number){
        this.tieuDeChiTietDSB = "THEO DÕI TRIỂN KHAI THIẾT BỊ VÀ CSHT";
        this.chiTietThietBiCSHT.IdCoQuan = item.ID;
        this.chiTietThietBiCSHT.Loai  = Loai;        
        this.lgModalChiTietDashBoard.show();        
        this.Load_dsChiTietThietBiCSHTKhuVuc();
    }
    dsChiTietThietBiCSHT:any=[];
    nChiTiet:number=0;
    Load_dsChiTietThietBiCSHTKhuVuc(){
        this.dashboardSevice.ds_ChiTietThietBiCSHTKhuVuc(this.chiTietThietBiCSHT).subscribe(
            resp=>{
                this.dsChiTietThietBiCSHT=[];
                this.dsChiTietThietBiCSHT = resp;
                this.nChiTiet = this.dsChiTietThietBiCSHT.length;
            }
        )        
    }
    xemChiTietThietBiCSHT(item, Loai:number){
        this.tieuDeChiTietDSB = "THEO DÕI TRIỂN KHAI THIẾT BỊ VÀ CSHT (" + item.TEN +")";
        this.chiTietThietBiCSHT.IdNhomQuyTrinh = item.ID;
        this.chiTietThietBiCSHT.IdCoQuan = this.auth.user.IdCoQuan;
        this.chiTietThietBiCSHT.Loai = Loai;        
        this.lgModalChiTietDashBoard.show();                
        this.Load_dsChiTietThietBiCSHT();
    }
    Load_dsChiTietThietBiCSHT(){
        this.dashboardSevice.ds_ChiTietThietBiCSHT(this.chiTietThietBiCSHT).subscribe(
            resp=>{
                this.dsChiTietThietBiCSHT=[];
                this.dsChiTietThietBiCSHT = resp;
                this.nChiTiet = this.dsChiTietThietBiCSHT.length;
            }
        )        
    }
    dsDashBoardThamDinhPhuongAn:any=[];
    Load_dsDashBoardThamDinhPhuongAn()
    {
        let TT={
            IdCoQuan:this.auth.user.IdCoQuan
        };
        this.dashboardSevice.ds_DashBoardThamDinhPhuongAn(TT).subscribe(
            resp=>{
                this.dsDashBoardThamDinhPhuongAn = resp;                                        
            }
        )
    } 
    dsDashBoardThamDinhPhuongAnTinh:any=[];
    Load_dsDashBoardThamDinhPhuongAnTinh()
    {
        let TT={
            IdCoQuan:this.auth.user.IdCoQuan
        };
        this.dashboardSevice.ds_DashBoardThamDinhPhuongAnTinh(TT).subscribe(
            resp=>{
                this.dsDashBoardThamDinhPhuongAnTinh = resp;                                        
            }
        )
    }     
    chiTietBoSungThietBi:any={};
    TieuDeMoDalBoSungThietBi:string="";
    xemChiTietBoSungThietBiTinh(item, Loai:number, MaGP:string){
        //this.tieuDeChiTietDSB = item;
        console.log(item);
        this.chiTietBoSungThietBi.IdCoQuan = item.ID;
        this.chiTietBoSungThietBi.Loai  = Loai;  
        this.chiTietBoSungThietBi.MaGiaiPhap = MaGP;
        if(Loai == 0){
            if(MaGP == 'REPEATER')
                this.TieuDeMoDalBoSungThietBi="Đề xuất bổ sung Repeater";
            else if(MaGP == 'SMC')
                this.TieuDeMoDalBoSungThietBi="Đề xuất bổ sung Small Cell";
            else if(MaGP == 'RSECTOR')
                this.TieuDeMoDalBoSungThietBi="Đề xuất bổ sung Remote Sector";
            else if(MaGP == 'SECTOR2G3G4G')
                this.TieuDeMoDalBoSungThietBi="Đề xuất bổ sung Sector";
            else if(MaGP == 'MACRO')
                this.TieuDeMoDalBoSungThietBi="Đề xuất bổ sung Macro";
        }else if(Loai == 1){
            if(MaGP == 'REPEATER')
                this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Repeater";
            else if(MaGP == 'SMC')
                this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Small Cell";
            else if(MaGP == 'RSECTOR')
                this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Remote Sector";
            else if(MaGP == 'SECTOR2G3G4G')
                this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Sector";    
        }else if(Loai == 2){
            this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Macro trong kế hoạch";
        }else if(Loai == 3){
            this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Macro có thể điều chỉnh kế hoạch";
        }else if(Loai == 4){
            this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Macro không thể điều chỉnh kế hoạch";
        }         
        this.lgModalHienThiChiTietBoSungThietBi.show();        
        this.Load_dsChiTietDeXuatBoSungThietBiTinh();
    }
    dsChiTietDeXuatBoSungThietBi:any=[];    
    Load_dsChiTietDeXuatBoSungThietBiTinh(){
        this.dashboardSevice.ds_ChiTietDeXuatBoSungThietBiTinh(this.chiTietBoSungThietBi).subscribe(
            resp=>{
                this.dsChiTietDeXuatBoSungThietBi=[];
                this.dsChiTietDeXuatBoSungThietBi = resp;                
            }
        )        
    }
    xemChiTietBoSungThietBi(item, Loai:number){
        this.chiTietBoSungThietBi.IdCoQuan = this.auth.user.IdCoQuan;
        this.chiTietBoSungThietBi.Loai  = Loai;  
        this.chiTietBoSungThietBi.MaGiaiPhap = item.MA;
        this.lgModalHienThiChiTietBoSungThietBi.show();
        if(Loai == 0){
            if(item.MA == 'REPEATER')
                this.TieuDeMoDalBoSungThietBi="Đề xuất bổ sung Repeater";
            else if(item.MA == 'SMC')
                this.TieuDeMoDalBoSungThietBi="Đề xuất bổ sung Small Cell";
            else if(item.MA == 'RSECTOR')
                this.TieuDeMoDalBoSungThietBi="Đề xuất bổ sung Remote Sector";
            else if(item.MA == 'SECTOR2G3G4G')
                this.TieuDeMoDalBoSungThietBi="Đề xuất bổ sung Sector";
            else if(item.MA == 'MACRO')
                this.TieuDeMoDalBoSungThietBi="Đề xuất bổ sung Macro";
        }else if(Loai == 1){
            if(item.MA == 'REPEATER')
                this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Repeater";
            else if(item.MA == 'SMC')
                this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Small Cell";
            else if(item.MA == 'RSECTOR')
                this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Remote Sector";
            else if(item.MA == 'SECTOR2G3G4G')
                this.TieuDeMoDalBoSungThietBi="Đề xuất được duyệt bổ sung Sector";    
        }
        this.Load_dsChiTietDeXuatBoSungThietBi();
    }
    Load_dsChiTietDeXuatBoSungThietBi(){
        this.dashboardSevice.ds_ChiTietDeXuatBoSungThietBi(this.chiTietBoSungThietBi).subscribe(
            resp=>{
                this.dsChiTietDeXuatBoSungThietBi=[];
                this.dsChiTietDeXuatBoSungThietBi = resp;                
            }
        )        
    }
    ds_DashBoardTongHopTon:any=[];
    DashBoardTongHopTon()
    {        
        this.dashboardSevice.DashBoardTongHopTon().subscribe(
            resp=>{
                this.ds_DashBoardTongHopTon = resp;                                        
            }
        )
    }
    chiTietPhieuTon:any={}; 
    TieuDeMoDalChiTietTon:string ="";   
    xemChiTietPhieuTon(Loai:number, HeThong:number){
        this.TieuDeMoDalChiTietTon = "DANH SÁCH PHIẾU ĐANG XỬ LÝ";
        this.chiTietPhieuTon.HeThong = HeThong;
        this.chiTietPhieuTon.Loai  = Loai;        
        this.lgModalChiTietPhieuTon.show();        
        this.Load_dsChiTietPhieuTon(1);
    }
    dsChiTietPhieuTon:any=[];    
    Stt:number=1;
    
    Load_dsChiTietPhieuTon(page){
        this.chiTietPhieuTon.Page = page;
        this.chiTietPhieuTon.Size = this.pagesize;
        this.Stt = (page-1)*this.pagesize + 1;
        if(this.Stt == 0) this.Stt=1;
        this.dashboardSevice.DashBoardChiTietTon(this.chiTietPhieuTon).subscribe(
            resp=>{
                this.totalPages = 0;
                this.dsChiTietPhieuTon=[];
                this.dsChiTietPhieuTon = resp; 
                if (this.dsChiTietPhieuTon.length !== 0)
                {
                    // tổng records trong list
                    this.paging = page;
                    this.totalCount = (this.dsChiTietPhieuTon[0]).TOTALROWS;
                    this.totalPages = Math.ceil(this.totalCount / this.pagesize); // tính tổng số trang cần phân dựa vào tổng records
                    
                    this.TaoTongTrang(this.paging, this.totalPages);
                }else{
                    this.TaoTongTrang(this.paging, this.totalPages);
                }                       
            }
        )        
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/home/home.component.ts